import React from 'react';
import { Route, Routes } from 'react-router-dom';

import TrackingComponent from "./components/pages/tracking.component";
import NotFoundComponent from "./components/pages/not-found.component";
import PrivacyPolicyComponent from './components/pages/privacy-policy.component';
import MainLayout from './components/layouts/main';

const AppRouter = () => {
    return (
        <Routes>
            <Route element={<MainLayout />}>
                <Route exact path='/:orderId?' element={<TrackingComponent />} />
                <Route exact path='/privacy-policy' element={<PrivacyPolicyComponent />} />
                <Route path='*' element={<NotFoundComponent />} />
            </Route>
        </Routes>
    )
}

export default AppRouter;